export default __webpack_public_path__ + "static/media/img04.cbd232bf.jpg";